import React from 'react';
import AdminFaqForm from '../components/admin/faq/AdminFaqForm';

const AdminFaqFormPage = () => {
    return (
        <AdminFaqForm />
    );
};

export default AdminFaqFormPage;